import React, { PureComponent } from "react";
import AsyncSelect from "react-select/async";
import { getGroups } from "Api";
import _ from "i18n";

export default class GroupsSelect extends PureComponent {
  //   isMulti,
  //   selectedGroups,
  //   organizationId,
  //   onChange
  // }) {

  fetchGroups = inputValue => {
    const { token, navCommunity } = this.props.auth;
    let customFilter = [];

    if (null !== inputValue) {
      customFilter = [
        {
          property: "name",
          value: inputValue,
          operator: "like"
        }
      ];
    }

    return getGroups({
      token,
      clientId: navCommunity.id,
      customFilter
    }).then(result => {
      return result.data.data;
    });
  };
  render() {
    const { selectedGroups, onChange } = this.props;
    console.log("llll");
    console.log(selectedGroups);
    return (
      <div style={{ marginBottom: "20px" }}>
        <AsyncSelect
          isMulti={true}
          cacheOptions
          value={selectedGroups}
          onChange={e => onChange(e)}
          loadOptions={this.fetchGroups}
          defaultOptions={true}
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          classNamePrefix="custom-select"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Settings/GroupsSelect.js